var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"bg-white text-white py-2 px-4 rounded items-center",class:[
    {'shadow' : _vm.isDefault},
    {'hover:bg-gray-100' : _vm.isDefault},
    {'text-support-300' : _vm.isDefault},
    {'border-gray-400' : _vm.isDefault},
    {'border' : _vm.isDefault},
    {'border-b-4' : _vm.is3D},
    {'border-secondary-700' : _vm.color == 'secondary'},
    {'bg-secondary-500' : _vm.color == 'secondary'},
    {'hover:border-secondary-500' : _vm.color == 'secondary'},
    {'hover:bg-secondary-300' : _vm.color == 'secondary'},
    {'inline-flex' : _vm.icon},
    {'w-full': _vm.isMobile},
    {'block': _vm.isMobile} ],attrs:{"to":_vm.to}},[(_vm.icon == 'download')?_c('svg',{staticClass:"fill-current w-4 h-4",class:[{'ml-2': _vm.isRtl},{'mr-2': !_vm.isRtl}],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"}})]):_vm._e(),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }